<template>
  <div :class="$style[classes]">
    <goods-divide :goodsTypeLoading="goodsTypeLoading" :goodsTypes="goodsTypes" @widthItem="widthItem" :businessDepartments="businessDepartments" :divideData="divideData"
    :addressList="addressList" :companyList="companyList" :isEdit="isEdit" :widthMax="width_max" v-model="goodsData" ref="divide" @change="changeDivide" @changeOtherInfo="changeOtherInfo"
    :pointsExchangeData="pointsExchangeData" @changeQuota="changeQuota" :pointsGoodsQuota="pointsGoodsQuota"></goods-divide>
    <pt-integral-goods-form-message :divideData="divideData" :goodsGroup="goodsGroup"  @widthItem="widthItem" :mallGoods="mallGoods"
    :widthMax="width_max" :isEdit="isEdit" :value="goodsData" ref="message" @change="changeMesaage"  :specification="specifications"></pt-integral-goods-form-message>
    <template>
    <pt-sub-title title="发货形式"></pt-sub-title>
    <table>
        <pt-form-list-item  width="5em" :required="true" class="pt-form-list-item-tr" label="发货形式："   @widthItem="widthItem"  :widthMax="width_max">
            <wt-radio v-model="shippingModeOfForm" :radios="shippingMode" data-vv-as="发货方式"
            name="shippingModes"  v-validate="'required'"></wt-radio>
        </pt-form-list-item>
    </table>
    <integral-goods-other-set :afterSalesPolicieList="afterSalesPolicieList" :carriagePoliciesList="carriagePoliciesList" :isEdit="isEdit"
    :privacyPolicyList="privacyPolicyList"  :value="policeData" @widthItem="widthItem" :widthMax="width_max" ref="set" @change="changeOtherSet"></integral-goods-other-set>
    </template>
        <pt-sub-title title="商品详情"></pt-sub-title>
        <wt-ueditor resource="goods" ref="ueditor"  v-model="goodsData.detail" :content="content" ></wt-ueditor>
  </div>
</template>

<script>
import formMixins from 'mixins/form'
import { maxValueMethod } from 'utils/formUtils'
import goodsDivide from './goods-divide'
import ptIntegralGoodsFormMessage from './integral-goods-form-message'
import integralGoodsOtherSet from './integral-goods-other-set'
import { shippingMode } from 'json/mall-options'
// 组件class前缀
const prefixCls = 'pt-integral-goods-form'

export default {
  name: 'pt-integral-goods-form',
  mixins: [formMixins],
  components: {
    goodsDivide,
    ptIntegralGoodsFormMessage,
    integralGoodsOtherSet
  },
  computed: {
    classes () {
      return `${prefixCls}`
    },
    divide () {
      return this.$refs.divide
    },
    message () {
      return this.$refs.message
    },
    set () {
      return this.$refs.set
    },
    mallGoods () {
      return this.goodsForm.mallGoods
    }
  },
  props: {
    goodsTypeLoading: Boolean,
    goodsTypes: Array,
    businessDepartments: Array,
    addressList: Array,
    companyList: Array,
    goodsGroup: Array,
    afterSalesPolicieList: Array,
    carriagePoliciesList: Array,
    privacyPolicyList: Array,
    content: String,
    goodsDetail: Object,
    goodsForm: Object,
    allMembers: Array,
    isEdit: Boolean
  },
  data () {
    return {
      formValue: {

      },
      widthArr: [],
      width_max: null,
      shippingMode: shippingMode,
      goodsData: {},
      divideData: {},
      form: this.isEdit ? JSON.parse(JSON.stringify(this.goodsForm)) : { },
      pointsExchangeData: [],
      specifications: [],
      policeData: {},
      shippingModeOfForm: null,
      pointsGoodsQuota: null
    }
  },
  watch: {
    allMembers: {
      handler: function (val) {
        if (this.allMembers && this.allMembers.length) {
          this.allMembers.forEach(item => {
            item.canBuy = false
          })
          this.pointsExchangeData = (this.pointsExchangeData && this.pointsExchangeData.length) ? this.pointsExchangeData : JSON.parse(JSON.stringify(this.allMembers))
        }
      },
      deep: true
    },
    goodsForm: {
      handler: function (val) {
        this.form = val
        this.goodsData = (val && val.goodsDTO && JSON.parse(JSON.stringify(val.goodsDTO.goodsData))) || { mallVisible: true, cycleType: 'NATURAL_DAY', provide_invoice: 'true' }
        this.specifications = JSON.parse(JSON.stringify(this.goodsData.specifications)) || []
        this.goodsOtherInfoDTO = val.goodsOtherInfoDTO || {}
        this.vendorInfo = (val && val.goodsDTO && val.goodsDTO.goodsData && val.goodsDTO.goodsData.vendorInfo) || {}
        this.shippingModeOfForm = this.goodsData.shippingMode
        this.pointsExchangeData = val.goodsDTO.pointsExchangeData || this.pointsExchangeData
        this.pointsGoodsQuota = val.goodsDTO.pointsGoodsQuota
        let { afterSalesPolicyId, afterSalesPolicyName, privacyPolicyId, privacyPolicyName, carriagePolicy, carriagePolicyId, carriagePolicyName } = this.goodsData
        this.policeData = { afterSalesPolicyId, afterSalesPolicyName, privacyPolicyId, privacyPolicyName, carriagePolicy, carriagePolicyId, carriagePolicyName }
      }
    },
    goodsData: {
      handler: function (val) {
        this.form.goodsDTO.goodsData = { ...this.form.goodsDTO.goodsData, ...val }
      },
      deep: true
    },
    shippingModeOfForm (val) {
      this.form.goodsDTO.goodsData.shippingMode = val
    }
  },
  methods: {
    changeQuota (val) {
      this.form.goodsDTO = this.form.goodsDTO || {}
      this.form.goodsDTO.pointsGoodsQuota = val
    },
    changeOtherInfo (val) {
      this.form.goodsOtherInfoDTO = { ...val }
    },
    changeDivide (val, pointsExchangeData) {
      this.form.goodsDTO = this.form.goodsDTO || {}
      this.form.goodsDTO.goodsData = { ...this.form.goodsDTO.goodsData, ...JSON.parse(val) }
      this.form.goodsDTO.pointsExchangeData = pointsExchangeData
      this.divideData = val
    },
    changeMesaage (val) {
      this.form.goodsDTO = this.form.goodsDTO || {}
      this.form.goodsDTO.goodsData = { ...this.form.goodsDTO.goodsData, ...JSON.parse(JSON.stringify(val)) }
    },
    changeOtherSet (val) {
      this.form.goodsDTO = this.form.goodsDTO || {}
      this.form.goodsDTO.goodsData = { ...this.form.goodsDTO.goodsData, ...val }
    },
    selectCoupon () {},
    widthItem (val) {
      // 用于所有子模块的label对齐
      // 每个子模块中，随意挑选一个pt-form-list-item（因为同一个子模块，label的宽度是相等的）,使用此函数，获取此子模块中左边td即label部分的宽度，
      // 获取到所有子模块的宽度后，取出最大值，在每个子模块任意pt-form-list-item中传入最大宽度
      this.widthArr.push(val)
      this.width_max = maxValueMethod(this.widthArr)
    }
  }

}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.pt-integral-goods-form{
  margin-top: 20px;
  :global{
    table{
  padding: 10px 20px;

    }
  }
}
</style>
